<script setup lang="ts">
import { SolButton } from '@solfacil/girassol'
import { useI18n } from 'vue-i18n'
import useAuth from '~/store-v2/auth/useAuth'
import usePartner from '~/store-v2/partners/usePartner'
import { useImpersonateStore } from '~/store/impersonate'

const router = useRouter()
const impersonateStore = useImpersonateStore()
const { t } = useI18n()

const { data: auth } = useAuth()
const basePartnerId = computed(() => {
  const perfil = auth.value?.me?.perfil
  if (perfil === 'admin' && impersonateStore.partnerId > 0) {
    return impersonateStore.partnerId.toString()
  }
  return auth.value?.person?.partner?.id?.toString() || ''
})
const { data: partner, isLoading: isLoadingPartner } = usePartner(basePartnerId)
const userIsOnBlockedList = computed(() => {
  return partner.value?.blocklist?.is_blocked || false
})

const hasFinancingPermission = computed(() => !!auth.value?.person?.partner?.permission?.financing)

function handleNewSimulation() {
  router.push(userIsOnBlockedList.value ? '/' : '/simulation/new')
}
</script>

<template>
  <div class="projects-in-progress-empty">
    <div class="empty-state-content">
      <img
        src="/images/empty-projects-overview.svg"
        alt="Empty projects"
        class="empty-state-image"
      >
      <div class="empty-state-text">
        <h3 class="empty-state-title">
          {{ t('overview.projects_in_progress.empty.title') }}
        </h3>
        <p class="empty-state-subtitle">
          {{ t('overview.projects_in_progress.empty.subtitle_line1') }}
          <br>
          {{ t('overview.projects_in_progress.empty.subtitle_line2') }}
        </p>
      </div>
      <SolButton
        v-if="hasFinancingPermission"
        id="new-simulation-empty"
        :disabled="userIsOnBlockedList"
        :loading="isLoadingPartner"
        @click="handleNewSimulation"
      >
        {{ t('overview.projects_in_progress.empty.new_simulation') }}
      </SolButton>
    </div>
  </div>
</template>

<style scoped lang="scss">
.projects-in-progress-empty {
  @apply flex items-center justify-center py-8;

  .empty-state-content {
    @apply flex flex-col items-center gap-6 max-w-[550px] text-center;

    .empty-state-image {
      @apply w-full max-w-[105px] h-auto;
    }

    .empty-state-text {
      @apply flex flex-col gap-2;

      .empty-state-title {
        @apply fonts-heading-h4 text-neutral-low-pure;
      }

      .empty-state-subtitle {
        @apply fonts-body-large-regular text-neutral-low-light;
      }
    }
  }
}
</style>
